<h2 mat-dialog-title>Clôturer la journée — {{ data.dayLabel }}</h2>

<mat-dialog-content>
	<p class="subtitle">
		{{ data.storeName }} — ce qui a été <b>réellement réalisé</b> aujourd'hui.
		@if (showBadged) {
			Pré-rempli avec le temps badgé, ou le planning à défaut de pointage.
		} @else {
			Pré-rempli avec le planning : corrigez les heures qui ont bougé, cochez les absents.
		}
		Les heures enregistrées ici font foi pour la paie.
	</p>

	@if (rows.length === 0) {
		<div class="empty">Personne n'était planifié ce jour-là.</div>
	} @else {
		<table class="close-grid">
			<thead>
				<tr>
					<th>Salarié</th>
					<th class="num">Prévu</th>
					@if (showBadged) { <th class="num">Badgé</th> }
					<th class="num paid">Réalisé</th>
					<th class="num">Écart</th>
					<th class="ok">Absent</th>
					<th>Précision</th>
				</tr>
			</thead>
			<tbody>
				@for (row of rows; track row.id_employee) {
					<tr [class.absent]="row.absent">
						<td class="name">
							{{ row.name }}
							@if (row.declared) {
								<span class="tag declared" matTooltip="Heures déclarées par le salarié — à confirmer">déclaré</span>
							}
						</td>
						<td class="num muted">{{ row.planned_min ? h(row.planned_min) : '—' }}</td>
						@if (showBadged) {
							<td class="num muted">
								@if (row.no_badge) {
									<span class="tag warn" matTooltip="Journée prévue, aucun pointage enregistré">Pas de badge</span>
								} @else {
									{{ h(row.badged_min) }}
								}
							</td>
						}
						<td class="num paid">
							<input type="number" min="0" step="0.25" class="paid-input" [disabled]="row.absent"
								[value]="paidHours(row)" (input)="onPaidHoursChange(row, $any($event.target).value)">
							<span class="unit">h</span>
						</td>
						<td class="num">
							@if (!row.absent && deltaLabel(row)) {
								<span [class.over]="row.delta_min > 0" [class.under]="row.delta_min < 0">{{ deltaLabel(row) }}</span>
							}
						</td>
						<td class="ok">
							<mat-checkbox [(ngModel)]="row.absent" (ngModelChange)="onAbsentChange(row)"
								matTooltip="N'est pas venu ce jour"></mat-checkbox>
						</td>
						<td><input type="text" class="cmt" [(ngModel)]="row.comment" placeholder="Motif de l'écart…"></td>
					</tr>
				}
			</tbody>
			<tfoot>
				<tr>
					<td>Total</td>
					<td class="num">{{ h(totals.planned_min) }}</td>
					@if (showBadged) { <td class="num"></td> }
					<td class="num paid">{{ h(totals.paid_min) }}</td>
					<td colspan="3" class="counts">
						@if (totals.absent > 0) {
							{{ totals.absent }} absent{{ totals.absent > 1 ? 's' : '' }}
						}
					</td>
				</tr>
			</tfoot>
		</table>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="onCancel()">Annuler</button>
	@if (rows.length > 0) {
		<button mat-stroked-button type="button" (click)="onConformeAuPlanning()"
			matTooltip="La journée s'est passée comme prévu">Conforme au planning</button>
		<button mat-flat-button color="primary" type="button" (click)="onSave()">Clôturer</button>
	}
</mat-dialog-actions>
